export default {
	"detailSplitDialog": {
		"relationCheckboxLable": "จำนวนสินค้าและจำนวนบรรจุภัณฑ์สัมพันธ์กับการปรับเปลี่ยนหรือไม่",
		"initialization": "มากกว่า 0 และต้องไม่เกินจำนวนเริ่มต้น",
		"confirmedSplit": "ยืนยันการแบ่ง"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/detailSplitDialog/detailSplitDialog.js